import { FC } from "react";
import "./Member.scoped.scss";
import { useRecoilState } from "recoil";
import { userBoxState } from "../../../atoms/common";
import roomDetailState from "../../../atoms/roomDetail";
import myInfoState from "../../../atoms/myinfo";

interface MemberProps {
  level: number;
  userId: string;
  nickname: string;
}

const Member: FC<MemberProps> = ({ level, userId, nickname }) => {
  const [userBox, setUserBox] = useRecoilState(userBoxState);
  const [roomDetail] = useRecoilState(roomDetailState);
  const [myInfo] = useRecoilState(myInfoState);

  const openUserBox = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (myInfo.id === 'admin' || roomDetail.managers.includes(myInfo.id)) {
      setUserBox({
        display: true,
        userId: userId,
        userName: nickname,
        x: e.clientX,
        y: e.clientY,
      });
    }
  }

  return (
    <div className="member">
      <img src={`/img/level/zb4/${level}.gif`} alt="" />
      <button style={{ lineHeight: '24px', padding: 0 }} className="no-close-user-box" onClick={openUserBox}>
        <b className="member__nickname">{nickname} {
          userId === 'admin' ? '(관리자)'
          : roomDetail.owner === userId ? '(방장)'
          : roomDetail.managers.includes(userId) ? '(매니저)'
          : ''
        }</b>
      </button>
      <span className="member__time"></span>
    </div>
  );
}

export default Member;